import React, { ComponentPropsWithRef, FC, PropsWithChildren } from 'react'

import clsx from 'clsx'
import styled, { css } from 'styled-components'

const Container = styled.div<{ showShadow: boolean }>`
  width: 28rem;
  height: 8.57rem;
  background-image: linear-gradient(
    -45deg,
    #eff1f4 25%,
    #fff 25%,
    #fff 50%,
    #eff1f4 50%,
    #eff1f4 75%,
    #fff 75%,
    #fff
  );
  background-size: 0.5rem 0.5rem;
  border-radius: var(--s-2);
  ${({ showShadow }) =>
    showShadow &&
    css`
      box-shadow: 0 0.07rem 0.07rem rgba(97, 108, 121, 0.1),
        0 0.5rem 1.29rem rgba(97, 108, 121, 0.13);
    `}
  overflow: hidden;
`

type DivProps = ComponentPropsWithRef<'div'>
type Props = DivProps & { showShadow?: boolean }

export const CommonContentItemBase: FC<PropsWithChildren<Props>> = ({
  showShadow = false,
  children,
  className,
  ...otherProps
}) => {
  return (
    <Container
      showShadow={showShadow}
      {...otherProps}
      className={clsx('tw-border-border-secondary', className)}
    >
      {children}
    </Container>
  )
}
